const news: any = [
  {
    index: 0,
    title: "Think BIG with ANGIE!",
    photo: require("../../public/images/newsImages/news1/news1_photo1.jpeg"),
    photo_2: require("../../public/images/newsImages/news1/news1_photo2.jpeg"),
    date: "23 November 2023",
    text: `
    <b>15-16.11.2023, Craiova, University House</b> <br/><br/>
    <p>This is the statement under which the first transnational meeting of the Academic Network for Innovative and Green Europe / ANGIE project took place.
    The representatives of 8 European universities and a university association met in Craiova to launch the newest project coordinated by the University of Craiova.</p>
    <br/>
    <p>It was a fruitful meeting, colleagues became friends, tasks became clear.
    The project is on, and in the next 24 months we will create a new master's study program dedicated to sustainable development for an innovative and eco Europe.</p>
    `,
    text_2: `
    <p>Participants:</p>
    <ol style="margin-left: 16px;">
      <li><b>Emmanuel Ohene</b> / ACEEU GmbH;</li>
      <li><b>Ines Ascenso Pires, Luís Alves</b> / UNIVERSIDADE DE LISBOA;</li>
      <li><b>Damjan Klobcar</b> / UNIVERZA V LJUBLJANI;</li>
      <li><b>Andrej David</b> / ZILINSKA UNIVERSITA V ZILINE;</li>
      <li><b>Giuseppe Casalino</b> / POLITECNICO DI BARI;</li>
      <li><b>Manuel Gonzalez Sanchez</b> / UNIVERSIDAD DE MALAGA;</li>
      <li><b>Bianca Duldner-Borca</b> / FH OO FORSCHUNGS & ENTWICKLUNGS GmbH;</li>
      <li><b>Mihnea Stoica</b> / BABEȘ-BOLYAI UNIVERSITY;</li>
      <li><b>Dănuț Savu, Gabriel Benga, Dorel Berceanu, Sorin Savu, Dalia Simion, Daniela Tarniță</b> / UNIVERSITY OF CRAIOVA;</li>
      <li>Students:
        <ul style="margin-left: 32px;">
          <li><b>Arianne-Maria Savu</b> / BABEȘ-BOLYAI UNIVERSITY;</li>
          <li><b>Alexandru-Andrei Avram</b> / TECHNICAL UNIVERSITY OF CLUJ-NAPOCA;</li>
          <li><b>Pavel Drăgan</b> / BUCHAREST TECHNICAL UNIVERSITY.</li>
        </ul>
      </li>
    </ol>
    `,
  },
  {
    index: 1,
    title: "University of Zilina (Slovakia)",
    subtitle: "Project partner: Department of Water Transport",
    photo: require("../../public/images/newsImages/news2/zilinska1.jpg"),
    photo_2: require("../../public/images/newsImages/news2/zilinska2.jpg"),
    date: "15 May 2024",
    text: `<p>University of Žilina (UNIZA) with 70 years of history belongs to one of the
    leading educational and scientific institutions in Slovakia. With its rich
    tradition it occupies a significant place among Slovak universities. This fact is
    not only connected with the number of students or offer of interesting and
    quality study programmes but the university also has the significant research
    and foreign activities. The current university is no longer focused only on
    transport and communications. It is a broadly-conceived university located in
    a unique university campus at Veľký Diel. It has seven faculties (the Faculty of
    Operation and Economics of Transport and Communications, the Faculty of
    Civil Engineering, the Faculty of Mechanical Engineering, the Faculty of
    Electrical Engineering and Information Technology, Faculty of Management
    Science and Informatics, the Faculty of Security Engineering, the Faculty of
    Humanities)</p>`,
    text_2: `<p>The Department of Water Transport is one of the profile departments of the
    Faculty of Operation and Economics of Transport and Communications at the
    University of Žilina (Slovakia). The Department was established in 1991 as a
    result of the lack of well-qualified staff who could work in the field of inland
    navigation in Slovakia.</p>
    <br/>
    <p>The study of water transport is modern, innovative, and interesting. The
    theoretical training is of high quality, including subjects recommended by
    practice. The innovative study includes a virtual environment in which
    students verify the acquired knowledge on a vessel control simulator in the
    department&#39;s specialized laboratory. Students will support their theoretical
    knowledge in practice through excursions in ports, terminals, institutions
    dealing with water transport and onboard. The Department of Water Transport
    closely cooperates with practices and companies that are among the largest
    and best in the field of water transport.</p>`,
  },
  {
    index: 2,
    title:
      'Graduate Study Program (GSP) "Transition to Green for Sustainable Society."',
    photo: require("../../public/images/newsImages/news3/newsletter2_img1.png"),
    photo_2: require("../../public/images/newsImages/news3/newsletter2_img2.png"),
    date: "12 December 2024",
    text: `
    <b>Curriculum Development</b> <br/><br/>
    <p>19 disciplines were selected through a collaborative process involving all partner institutions, ensuring relevance to regional and global sustainability challenges. These disciplines cover interdisciplinary topics across the seven domains critical for sustainability, namely:</p>
    <ul>
      <li>Construction</li>
      <li>Industrial Activities</li>
      <li>Transportation</li>
      <li>Waste</li>
      <li>Energy Production</li>
      <li>Residential Activities</li>
      <li>Agriculture</li>
    </ul>
    <br/>
    <p>Transversal themes such as European Environmental Law, Digitalization, and Soft Skills for ”Green Transition” were also highlighted.</p>
    `,
    text_2: `
    <b>Competencies and Learning Outcomes:</b> <br/><br/>
    <p>Competencies and Learning Outcomes were defined for each discipline, and divided into:</p>
    <ul>
      <li>
        <strong>Technical skills:</strong> such as Life Cycle Assessment (LCA), circular economy strategies, and renewable energy integration.
      </li>
      <li>
        <strong>Soft skills:</strong> such as Ethical decision-making, stakeholder communication, and interdisciplinary collaboration.
      </li>
    </ul>
    <br/>
    <br/>

    <b>Main Structure of the New GSP:</b> <br/><br/>
    <ul>
      <li>
        <strong>Innovative Pedagogy:</strong> Emphasis on active learning (PBL, EBL) and interdisciplinary approaches.
      </li>
      <li>
        <strong>Practical Focus:</strong> Real-world applications through projects, case studies, and industry collaboration.
      </li>
      <li>
        <strong>Tailored Communication:</strong> Methods adapted for trainers (teaching tools), specialists (technical depth), and authorities (policy frameworks).
      </li>
      <li>
        <strong>Holistic Curriculum:</strong> Combines technical knowledge, soft skills, and sustainability practices.
      </li>
    </ul>
    <br/>
    <b>Together, we’re shaping the future of sustainable education!</b>
    `,
  },
  {
    index: 3,
    title: "Upcoming Dissemination and Piloting Activities",
    photo: require("../../public/images/newsImages/news4/newsletter3_img1.png"),
    photo_2: require("../../public/images/newsImages/news4/newsletter3_img2.png"),
    date: "26 May 2025",
    text: `
    <p>As the ANGIE project moves into its key dissemination phase, we are glad to share with you the activities ahead. Over the next months, we will roll a series of dissemination and piloting activities to ensure that ANGIE’s messages, methods, and materials reach the target audience. Whether you are a student, faculty, professional, or policymaker, there is a place for you in our green transition conversations.</p>
    <br/><br/>
    <b>What We Aim to Achieve:</b> <br/><br/>
    <ul>
      <li>Foster a shift in awareness and behavior among stakeholders in the WATERIC sectors (Transportation, Energy Production, Agriculture, Waste Management, Construction, Industrial Activities, and Residential Activities) to address climate change. </li>
      <li>Improve the knowledge and skills of the educators from WATERIC sector.</li>
      <li>Improve the knowledge and skills of the specialists involved in the design and operation of systems acting in WATERIC sectors.</li>
      <li>To test the ANGIE Graduate Study Program in pilot learning activities.</li>
    </ul>
    <br/>
    `,
    text_2: `

    <b>Dissemination Activities at a Glance</b> <br/><br/>
    <ul>
      <li>Eight (8) National Workshops for female educators (at any level)</li>
      <li>Eight (8) National Roundtables for stakeholders in the WATERIC sector.</li>
      <li>Eight (8) National Seminars for educators and academics</li>
      <li>Three (3) International Webinars for professionals, teachers, trainers, and stakeholders approaching green transition.</li>
      <li> Three (3) International Blended Course Piloting on (I) Fabrication and Environment, (II) Logistics, Transportation and Environment, (III) Waste Management and Environment. The target group include students, teachers, trainers, and profession  als. </li>
      <li>(1) Show Kit containing training materials</li>
    </ul>
    <br/>

    <b>Participants will</b> <br/><br/>
    <ul>
      <li>Explore how different industrial sectors affect the environment and identify opportunities for sustainable change within (e.g. fabrication, transport, and waste).</li>
      <li>Build alignment with green transition strategies</li>
      <li>Gain awareness on climate change and green transition</li>
      <li>Learn to apply green skills in real-world contexts (e.g. fabrication, waste, and logistics)</li>
      <li>Gain pedagogical, communication, and assessment skills for teaching climate change and green transition.</li>
      <li>Be exposed to best practices and case examples on green transition</li>
      <li>Have access to a repository of ANGIE learning materials and contents related to climate change and green transition</li>
    </ul>
    <br/>
    `,
  },
].sort((a: any, b: any) => {
  return new Date(b.date).getTime() - new Date(a.date).getTime();
});
export default news;
